const MAX_RETRY_ATTEMPTS = 5
const DEFAULT_TIME_UNTIL_NEXT_RETRY = 5000 // ms

const getDefaultState = () => {
  return {
    loadingCount: 0,
    accessToken: '',
    webSocketToken: '',
    retries: 0,
    timeUntilNextRetry: DEFAULT_TIME_UNTIL_NEXT_RETRY,
    retryIntervalRef: null, // will hold reference to interval timer
  }
}

const state = getDefaultState()

export default {
  namespaced: true,
  state,

  getters: {
    isLoading: (state) => state.loadingCount > 0,
    isSignalRInit: (state, getters) =>
      !!getters.getAccessToken && !!getters.getWebSocketToken,
    getAccessToken: (state) => state.accessToken,
    getWebSocketToken: (state) => state.webSocketToken,
    getRetries: (state) => state.retries,
    getTimeTillNextRetry: (state) => state.timeUntilNextRetry,
    hasExceededRetryLimit: (state) => state.retries > MAX_RETRY_ATTEMPTS,
    getIntervalRef: (state) => state.retryIntervalRef,
  },

  mutations: {
    START_LOADING(state) {
      state.loadingCount++
    },
    FINISH_LOADING(state) {
      state.loadingCount--
    },
    SET_PROMISE(state, promise) {
      state.startedPromise = promise
    },
    SET_TOKEN(state, token) {
      state.accessToken = token
    },
    SET_WEB_SOCKET_TOKEN(state, token) {
      state.webSocketToken = token
    },
    INCREMENT_RETRY_COUNT(state, amount = 1) {
      state.retries += amount
      state.timeUntilNextRetry += 500 * state.retries
    },
    CLEAR_RETRY_COUNT(state) {
      state.retries = 0
      state.timeUntilNextRetry = DEFAULT_TIME_UNTIL_NEXT_RETRY
    },
    CLEAR_STORE(state) {
      // Resets store to default state
      Object.assign(state, getDefaultState())
    },
  },

  actions: {
    /**
     * Resets store to default state.
     */
    clear({ commit }) {
      commit('CLEAR_STORE')
    },
  },
}
